import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CharacterService {

  _baseURL: string = "api/Character";

  constructor(private http: HttpClient) { }

  getAllCharacters() {
    return this.http.get<Character[]>(this._baseURL + "/GetAll");
  }
}
